import {
  POSITION_TRACKER_FETCH_REQUEST,
  POSITION_TRACKER_FETCH_SUCCESS,
  POSITION_TRACKER_FETCH_FAILURE,
  POSITION_TRACKER_SET_SEARCH,
  POSITION_TRACKER_ADD_REQUEST,
  POSITION_TRACKER_ADD_SUCCESS,
  POSITION_TRACKER_ADD_FAILURE,
  POSITION_TRACKER_UPDATE_REQUEST,
  POSITION_TRACKER_UPDATE_SUCCESS,
  POSITION_TRACKER_UPDATE_FAILURE,
  POSITION_TRACKER_DELETE_REQUEST,
  POSITION_TRACKER_DELETE_SUCCESS,
  POSITION_TRACKER_DELETE_FAILURE,
} from '../actions/actionTypes';

interface PositionTrackerState {
  positions: any[];
  loading: boolean;
  error: string | null;
  search: string;
  addLoading: boolean;
  updateLoading: boolean;
  deleteLoading: boolean;
}

const initialState: PositionTrackerState = {
  positions: [],
  loading: false,
  error: null,
  search: '',
  addLoading: false,
  updateLoading: false,
  deleteLoading: false,
};

export default function positionTrackerReducer(
  state = initialState,
  action: any,
): PositionTrackerState {
  switch (action.type) {
    case POSITION_TRACKER_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case POSITION_TRACKER_FETCH_SUCCESS:
      return { ...state, loading: false, positions: action.payload };
    case POSITION_TRACKER_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case POSITION_TRACKER_SET_SEARCH:
      return { ...state, search: action.payload };

    case POSITION_TRACKER_ADD_REQUEST:
      return { ...state, addLoading: true };
    case POSITION_TRACKER_ADD_SUCCESS:
      return { ...state, addLoading: false };
    case POSITION_TRACKER_ADD_FAILURE:
      return { ...state, addLoading: false };

    case POSITION_TRACKER_UPDATE_REQUEST:
      return { ...state, updateLoading: true };
    case POSITION_TRACKER_UPDATE_SUCCESS:
      return { ...state, updateLoading: false };
    case POSITION_TRACKER_UPDATE_FAILURE:
      return { ...state, updateLoading: false };

    case POSITION_TRACKER_DELETE_REQUEST:
      return { ...state, deleteLoading: true };
    case POSITION_TRACKER_DELETE_SUCCESS:
      return { ...state, deleteLoading: false };
    case POSITION_TRACKER_DELETE_FAILURE:
      return { ...state, deleteLoading: false };

    default:
      return state;
  }
}
